import type { TonalTokens } from "../../../polish/tokens";

// The hub's two heading levels: a section (This week, Reported), then a
// report day within Reported; and a card's own title on the report page.

export const sectionTitleSx = (tokens: TonalTokens) =>
  ({
    fontSize: { xs: "1.375rem", md: "1.625rem" },
    lineHeight: { xs: "30px", md: "34px" },
    fontWeight: 700,
    letterSpacing: "-0.02em",
    color: tokens.text,
  }) as const;

/** Under a section title, before its first card or day. */
export const SECTION_TITLE_GAP = { xs: 2.5, md: 3 } as const;

export const dayHeadingSx = (tokens: TonalTokens) =>
  ({
    flex: "none",
    fontSize: { xs: "0.9375rem", md: "1rem" },
    lineHeight: "24px",
    fontWeight: 600,
    letterSpacing: "-0.005em",
    color: tokens.text,
  }) as const;

/** A card's title on the report page: Results, Price targets, Analyst notes, Previous reports. */
export const cardHeadingSx = (tokens: TonalTokens) =>
  ({
    fontSize: { xs: "1.0625rem", md: "1.125rem" },
    lineHeight: "26px",
    fontWeight: 700,
    letterSpacing: "-0.01em",
    color: tokens.text,
  }) as const;
